import BandPostCard from "./BandPostCard";
import artistFallback from "../../assets/fallback/artist_fallback.webp";

const BandPostsCards = ({ data }) => {
  if (!data || !data.posts?.length) return null;
  const profileImage = data.band.image_profile || artistFallback;
  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4 px-1">
        <p className="text-blue-500 text-xs font-bold tracking-wider uppercase">
          Senaste nytt
        </p>
        <a
          href={`/search?posts=${data.band.slug}`}
          className="text-xs text-base-content/50 hover:text-white uppercase font-bold tracking-wider transition-colors"
        >
          Se alla →
        </a>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {data.posts.map((post, index) => (
          <BandPostCard
            key={index}
            post={post}
            bandName={data.band.name}
            bandSlug={data.band.slug}
            bandProfileImage={profileImage}
          />
        ))}
      </div>
    </div>
  );
};

export default BandPostsCards;
